import React from 'react';
import clsx from 'clsx';
import TranslationNamespaces from '../locales/TranslationNamespaces';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from '@mui/material';
import { useTheme, Theme } from '@mui/material/styles';
import { QLanguageSpeedDial, QDarkmodeToggle } from '@kubiq-base/core';
import { Link, Routes, Route } from 'react-router-dom';
import { useCache } from '../state/CachingContext';
import { ReactComponent as Logo } from '../assets/atiqx_id_logo_white.svg';
import { ReactComponent as AtiQxID } from '../assets/atiqx_id_main_image.svg';
import PageError from './Shared/PageError';

import Auth from './Auth/';
import Enable2FA from './Enable2FA/';
import RequestRecovery from './Recovery/';
import Register from './Register/Register';
import RegisterVerification from './Register/RegisterVerfication';
import Request2FAReset from './Recovery/Verify2FAReset';
import VerifyPasswordReset from './Recovery/VerifyPasswordReset';
import VerifyRemoveAccount from './Recovery/VerifyRemoveAccount';
import VerifyPhone from './VerifyPhone/VerifyPhone';
import IdpHandler from './Auth/IdpHandler';
import Logout from './Logout/Logout';

import { Root, classes } from './Main.styles';

const Main = (): JSX.Element => {
  const { t } = useTranslation(TranslationNamespaces.global);
  const theme = useTheme();
  const { getCache } = useCache();
  const [sessionExpired, setSessionExpired] = React.useState(false);

  const session = getCache();

  const sm = !useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));
  const lg = !useMediaQuery((theme: Theme) => theme.breakpoints.up('lg'));

  React.useEffect(() => {
    if (session.requestid)
      setTimeout(() => {
        console.log('Request ID has expired');
        setSessionExpired(true);
      }, 270000);
  }, []);

  return (
    <Root lg={lg}>
      <div className={classes.leftWrapper}>
        <div className={classes.circle} />

        <div
          className={classes.logo}
          {...(theme.palette.primary.contrastText !== '#fff' && {
            style: { filter: 'invert(1)' },
          })}
        >
          <Link to='/'>
            <Logo />
          </Link>
        </div>

        <div className={classes.AtiQxID}>
          <AtiQxID width='65%' height='100%' />
        </div>
      </div>

      <div className={classes.rightWrapper}>
        {(lg || sm) && (
          <div
            className={classes.logoMobile}
            {...(theme.palette.mode === 'light' && {
              style: { filter: 'invert(1)' },
            })}
          >
            <Link to='/' style={{ height: 24 }}>
              <Logo height='24px' />
            </Link>
          </div>
        )}

        <div className={clsx(classes.topbar)}>
          <div style={{ display: 'flex' }}>
            <QDarkmodeToggle />
            <QLanguageSpeedDial />
          </div>
        </div>

        <div className={classes.content}>
          <div style={{ display: 'flex', justifyContent: 'center', width: '100%', overflow: 'overlay' }}>
            <div
              style={{
                width: sm ? '100%' : lg ? '60%' : '70%',
                height: 'auto',
                justifyContent: 'center',
              }}
            >
              <Routes>
                <Route path='/' element={<Auth />} />
                <Route path='/Auth/*' element={<Auth />} />
                <Route path='/Register' element={<Register />} />
                <Route path='/RegisterAccount/Verify/' element={<RegisterVerification />} />
                <Route path='/Enable2FA/*' element={<Enable2FA />} />
                <Route path='/VerifyPhone' element={<VerifyPhone />} />
                <Route path='/Recovery/*' element={<RequestRecovery />} />
                <Route path='/ResetAuthenticator/Verify' element={<Request2FAReset />} />
                <Route path='/ResetPassword/Verify' element={<VerifyPasswordReset />} />
                <Route path='/RemoveAccount' element={<VerifyRemoveAccount />} />
                <Route path='/Logout' element={<Logout />} />
                <Route path='/IdpHandler' element={<IdpHandler />} />
                <Route
                  path='*'
                  element={
                    <PageError
                      code='404'
                      message={`${t('notExistSuffix')} "${window.location.pathname}" ${t('notExist')}`}
                    />
                  }
                />
              </Routes>
            </div>
          </div>
        </div>
      </div>
    </Root>
  );
};

export default Main;
